/* ========================================
   CARD FLIP FUNCTION
   ======================================== */

// Função global para flip dos cards
window.flipCard = function (cardId) {
  const cardContainer = document.getElementById(cardId);
  if (cardContainer) {
    cardContainer.classList.toggle('flipped');
  }
};
